import { FeatureName, TaxForm, TaxFormType } from '@bybeam/platform-types';
import useApplication from '@platform-ui-common/hooks/contexts/useApplication.js';
import useProgram from '@platform-ui-common/hooks/contexts/useProgram.js';
import useApplicationConfig from '@platform-ui/application/hooks/useApplicationConfig.js';
import { W9Form } from '@platform-ui/claim/pages/index.js';
import { makeRoute } from '@platform-ui/utilities/Routes.js';
import {
  getApplicantSections,
  getNextPage,
  getQuestion,
} from '@platform-ui/utilities/application/config.js';
import { SpecialQuestionKeys } from '@platform-ui/utilities/application/configs/standards/types.js';
import { getQuestionRoute } from '@platform-ui/utilities/application/question.js';

function useNextUrl(): string {
  const application = useApplication();
  const config = useApplicationConfig();
  const program = useProgram();
  const question = getQuestion(config, SpecialQuestionKeys.W9);
  if (question)
    return makeRoute(
      getNextPage(config, question, application.answers, program, [
        { type: TaxFormType.W9 } as TaxForm,
      ]),
      { applicationId: application.id },
    );

  const questions = getApplicantSections(config).flatMap(({ questionGroups }) =>
    questionGroups.flatMap(({ questions }) => questions),
  );
  // after submitting the W9 tax form, we should be redirected to the last question of the last section
  const lastQuestionIndex = questions.length - 1;
  const lastQuestion = questions[lastQuestionIndex];
  return makeRoute(getQuestionRoute(lastQuestion), { applicationId: application.id });
}

export default function ApplicationW9(): JSX.Element {
  const necessaryFeatures = [FeatureName.TaxFormsW9Collection, FeatureName.PaymentsPartnerIssued];
  const nextRoute = useNextUrl();

  return <W9Form necessaryFeatures={necessaryFeatures} redirectToUrl={nextRoute} />;
}
